import { doErrorPageRedirect } from 'owa-shared-start/lib/doErrorPageRedirect';
import { getApp, getClientId } from 'owa-config';
import { redirectToOwa } from 'owa-shared-start/lib/redirectToOwa';
import { redirect, redirectTo } from './redirect';
import getHeader from 'owa-shared-start/lib/getHeader';
import { languagePostOnBootError } from 'owa-shared-start/lib/languagePostOnBootError';
import { BootResult } from 'owa-shared-start/lib/interfaces/BootResult';
import BootError from 'owa-shared-start/lib/interfaces/BootError';
import ErrorDiagnostics from 'owa-shared-start/lib/interfaces/ErrorDiagnostics';
import RetryStrategy from 'owa-shared-start/lib/interfaces/RetryStrategy';
import { doErrorRetryRedirect } from 'owa-shared-start/lib/doErrorRetryRedirect';
import { getRedirectInProgress, setRedirectInProgress } from './isBootError';

export function handleBootErrorForMini(
    bootResult: BootResult,
    error: BootError,
    retryStrategy: RetryStrategy | null,
    errorDiagnostics: ErrorDiagnostics,
    onFatalBootError?: () => void
): Promise<boolean | void> {
    // Do not do the custom redirection if already there is a redirection in progress
    if (getRedirectInProgress()) {
        return Promise.resolve(null);
    }

    // Check if we need retry before render error page
    let didRedirect: boolean = false;
    const expectedVdir = getHeader(error?.response, 'X-Js-ClientVdir');
    if (expectedVdir && bootResult === 'optin') {
        didRedirect = redirectToOwa(expectedVdir, getApp());
    } else if (bootResult === 'langtz') {
        return languagePostOnBootError();
    } else if (bootResult === 'errorfe' && error.response?.url) {
        didRedirect = redirectTo(error.response.url);
    } else if (bootResult === 'auth') {
        didRedirect = redirect(location, 'authRedirect', 'true', undefined, true);
        didRedirect && setRedirectInProgress(true);
    } else if (retryStrategy) {
        didRedirect = doErrorRetryRedirect(retryStrategy);
    }

    if (!didRedirect) {
        // No retry is needed, redirect to error page
        const query = `app=${getApp()}&st=${errorDiagnostics.st}&ru=${
            window?.location?.pathname
        }&msg=${errorDiagnostics.emsg}&et=${errorDiagnostics.et}&esrc=${
            errorDiagnostics.esrc
        }&err=${encodeURIComponent(<any>errorDiagnostics.err)}&wsver=${
            errorDiagnostics.ewsver
        }&ebe=${errorDiagnostics.ebe}&efe=${errorDiagnostics.efe}&reqid=${
            errorDiagnostics.reqid
        }&cId=${getClientId()}&estack=${encodeURIComponent(errorDiagnostics.estack || '')}`;

        onFatalBootError?.();

        doErrorPageRedirect(query);
    }

    return Promise.resolve();
}
